import mock from "../../../fake-db/mock.js"
const data = {
    fonctionnality:{
        intro: 'MultiTRADE dispose de toutes les fonctionnalités nécessaires à l\'exercice commercial.',
        foncts: [
            {
                delay: 100,
                image: '../../../../images/icon/icon1.png',
                title: 'Mono/Multi-Caisses',
                detail: 'Bien contrôler vos Fonds ! Encaissement en Mono ou en Multi-caisses. Situation de trésorerie en temps réel. Billetage et arrêts de caisse par caisse. '
            },
            {
                delay: 200,
                image: '../../../../images/icon/credit.png',
                title: 'Crédits Clients',
                detail: 'Tenez des comptes fiables de vos clients : pour vos ventes à crédit, consultez facilement leurs situations de compte, et encaissez leurs paiements même si c’est partiellement.'
            },
            {
                delay: 300,
                image: '../../../../images/icon/tiers.png',
                title: 'Tiers-payant',
                detail: 'Pour les sociétés et assurances qui se chargent du paiement de vos factures mensuelles, vous les contrôlez et les imprimez rapidement en quelques clics seulement.'
            },
            {
                delay: 100,
                image: '../../../../images/icon/credit-fourn.png',
                title: 'Crédits Fournisseurs',
                detail: 'Tenez des comptes fiables de vos fournisseurs : situations et historiques de compte. Enregistrez les paiements de vos factures même partiellement.'
            },
            {
                delay: 200,
                image: '../../../../images/icon/tableau-bord.png',
                title: 'Tableau de Bord',
                detail: 'Il affiche des graphes indiquant l’évolution : de votre chiffre d’affaire, du nombre de clients, du panier moyen... Et affiche des alertes de ruptures et d\'impayés...'
            },
            {
                delay: 300,
                image: '../../../../images/icon/aide.png',
                title: 'Préparation des commandes',
                detail: 'Proposition de quantités à commander, comparaison de prix fournisseurs,  production de bons de commande en automatique ou en manuel.'
            },
            {
                delay: 100,
                image: '../../../../images/icon/lot.png',
                title: 'Lot de fabrication',
                detail: 'Enregistrés pendant la saisie des factures fournisseurs, les lots de fabrication de chaque produit sont repérables facilement et consultables en un seul clic.'
            },
            {
                delay: 200,
                image: '../../../../images/icon/date.png',
                title: 'Date de péremption',
                detail: 'Identifiez visuellement vos périmés avec des codes couleurs par période. Vous saurez en un clic valeurs, leurs provenances, les quantités achetées et les parties périmées.'
            },
            {
                delay: 300,
                image: '../../../../images/icon/depot.png',
                title: 'Dépôt-vente',
                detail: 'Il est possible de gérer les produits en dépôt vente et de suivre leur traces à chaque étape (en stock, vendu, facturable, facturé, payé, retour d’invendu ...)'
            },
            {
                delay: 100,
                image: '../../../../images/icon/magasin.png',
                title: 'Multi-magasins de stockage',
                detail: 'Il permet de gérer plusieurs magasins de stockage. En un ou deux clics, vous avez la répartition de votre stock. Il qui permet ensuite d’approvisionner facilement comptoir de vente. '
            },
            {
                delay: 200,
                image: '../../../../images/icon/Détail3.jpg',
                title: 'Géstion des détails',
                detail: 'Automatisez la gestion de vos produits en détails (pièce, kg, paquet … ). Gérer leur stock et leurs prix de vente n\'ont jamais été rendus aussi faciles.'
            },
            {
                delay: 300,
                image: '../../../../images/icon/pack.png',
                title: 'Pack de produits',
                detail: 'Vous pouvez créer des packs de produits que vous pourrez vendre en promotion. Vous pourrez contrôler leurs stocks et aussi gérer facilement leurs prix de vente.'
            },
            // {
            //     delay: 100,
            //     image: '../../../../images/fond/fond1.jpg',
            //     title: 'Vidal® et Hors-vidal',
            //     detail: 'Nous préparons maintenant la liaison de PharmaPLUS à la base Vidal et à une Base annexe de tous les produits pharmaceutiques vendus à Madagascar.'
            // }
        ]
    }
}

mock.onGet("/api/fonctionnality/all").reply(() => {
    return [200, data.fonctionnality];
});